import { useState } from "react";
import "./ReviewsCarousel.css";

const BASE = "";

function Stars({ rating }) {
  return (
    <div className="stars">
      {[1, 2, 3, 4, 5].map((s) => (
        <span key={s} style={{ color: s <= rating ? "var(--accent-gold)" : "var(--peach)" }}>
          ★
        </span>
      ))}
    </div>
  );
}

export default function ReviewsCarousel({ reviews }) {
  const [current, setCurrent] = useState(0);
  const [activeImage, setActiveImage] = useState(null);

  if (!reviews || reviews.length === 0) return null;

  const perPage = window.innerWidth < 768 ? 1 : window.innerWidth < 1024 ? 2 : 3;
  const maxPage = Math.max(0, reviews.length - perPage);

  const prev = () => setCurrent((c) => Math.max(0, c - 1));
  const next = () => setCurrent((c) => Math.min(maxPage, c + 1));

  const visible = reviews.slice(current, current + perPage);

  return (
    <div className="reviews-carousel">
      <div className="reviews-track">
        {visible.map((review) => (
          <div key={review.id} className="review-card">
            <Stars rating={review.rating} />
            <p className="review-text">«{review.text}»</p>
            {(review.photos || []).length > 0 && (
              <div className="review-photos">
                {(review.photos || []).map((p, i) => (
                  <img
                    key={i}
                    src={BASE + p}
                    alt="фото відгуку"
                    className="review-photo"
                    onClick={() => setActiveImage(BASE + p)}
                  />
                ))}
              </div>
            )}
            <div className="review-author">
              <div className="review-avatar">
                {review.avatar ? (
                  <img src={BASE + review.avatar} alt={review.name} />
                ) : (
                  review.name.charAt(0).toUpperCase()
                )}
              </div>
              <span>{review.name}</span>
            </div>
          </div>
        ))}
      </div>

      {reviews.length > perPage && (
        <div className="reviews-controls">
          <button className="reviews-arrow" onClick={prev} disabled={current === 0}>
            ‹
          </button>
          <div className="reviews-dots">
            {Array.from({ length: maxPage + 1 }).map((_, i) => (
              <button
                key={i}
                className={`dot ${i === current ? "active" : ""}`}
                onClick={() => setCurrent(i)}
              />
            ))}
          </div>
          <button className="reviews-arrow" onClick={next} disabled={current === maxPage}>
            ›
          </button>
        </div>
      )}
      {activeImage && (
        <div className="lightbox" onClick={() => setActiveImage(null)}>
          <img src={activeImage} alt="preview" />
        </div>
      )}
    </div>
  );
}
